import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { loadAnalytics, shouldTrackPath, trackPageView } from "../lib/analytics";

export const Analytics = () => {
  const location = useLocation();
  const lastTrackedPath = useRef(null);

  useEffect(() => {
    if (!shouldTrackPath(location.pathname) || lastTrackedPath.current === location.pathname) return;
    lastTrackedPath.current = location.pathname;
    loadAnalytics();
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
};
